function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l, jsxs as i } from "react/jsx-runtime";
import { useTheme as a } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: r , size: h = 24  } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const v = n(), e = r !== null && r !== void 0 ? r : v ? t.colors.inverse : t.colors.neutralHigh, { skinName: o  } = a();
    return o.match(/^vivo-new/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ l("path", {
            fill: e,
            d: "M18.322 12.042h1.754c.278 0 .438-.149.486-.26l.002-.005a.22.22 0 00.018-.137.316.316 0 00-.096-.159l-8.082-7.95c-.055-.055-.197-.131-.412-.131-.215 0-.354.076-.407.129l-.002.001-8.087 7.96a.296.296 0 00-.092.15.226.226 0 00.02.14l.001.006c.048.11.208.259.486.259h1.636v8.183c0 .057.024.134.11.213a.59.59 0 00.4.145h11.756a.59.59 0 00.399-.145c.086-.078.11-.156.11-.216v-8.183zm3.04-1.453c.468.46.602 1.107.347 1.69-.266.616-.91 1.013-1.633 1.013h-.504v6.933c0 .888-.79 1.61-1.76 1.61H6.058c-.97 0-1.76-.722-1.76-1.607v-6.933h-.386c-.723 0-1.367-.398-1.633-1.014-.255-.583-.123-1.232.347-1.69l8.081-7.951c.662-.653 1.91-.653 2.575 0l8.08 7.95z"
        })
    })) : o.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: e,
                d: "M13.577 14.289v3.2h-3.2v-3.2h3.2z"
            }),
            /* @__PURE__ */ l("path", {
                fill: e,
                d: "M11.977 2l10.001 10-.481 1.162h-1.916v5.378c0 1.33-1.082 2.41-2.411 2.41H6.784a2.414 2.414 0 01-2.411-2.41v-5.378H2.457L1.976 12 11.977 2zm6.243 9.802h1.635l-7.878-7.879-7.879 7.879h1.635v6.738c0 .58.472 1.05 1.051 1.05H17.17c.579 0 1.05-.47 1.05-1.05v-6.738z"
            })
        ]
    })) : o.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ l("path", {
            fill: e,
            d: "M11.99 2l9.321 10.036c.206.18.274.5.13.748-.103.284-.343.464-.614.464h-1.36V22h-5.782v-6.428h-3.403V22H4.5v-8.716H3.14c-.275 0-.51-.212-.614-.464-.103-.284-.068-.568.137-.784L11.99 2zm3.06 12.144v6.424h3.06V11.82h1.193l-7.314-7.856-7.317 7.856h1.193v8.752h3.06v-6.428h6.124z"
        })
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ l("path", {
            fill: e,
            d: "M14.942 21.841h2.877c.969 0 1.759-.722 1.759-1.61v-6.933h.504c.723 0 1.367-.398 1.633-1.014.255-.583.12-1.23-.347-1.69l-8.081-7.949c-.664-.652-1.914-.652-2.575 0l-8.08 7.953c-.471.456-.603 1.106-.348 1.689.266.616.91 1.014 1.633 1.014h.386v6.932c0 .886.79 1.608 1.76 1.608h3.044a.616.616 0 00.625-.605v-3.759h4.585v3.76c.006.341.286.61.625.604zm2.877-1.21h-2.25v-3.759a.614.614 0 00-.624-.605H9.107a.616.616 0 00-.627.605v3.762H6.063c-.278 0-.505-.18-.505-.4v-7.538a.614.614 0 00-.624-.605H3.917c-.266 0-.423-.14-.48-.272-.041-.095-.06-.235.085-.378l8.081-7.95c.196-.193.591-.193.787 0l8.084 7.944c.146.146.126.283.087.378-.056.135-.213.275-.479.275h-1.129a.617.617 0 00-.627.605v7.538c0 .22-.227.4-.507.4z"
        })
    }));
}, H = s;
export { H as default };
